"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ADD_DATA_ID", {
  enumerable: true,
  get: function get() {
    return _defaultSettings.ADD_DATA_ID;
  }
});
Object.defineProperty(exports, "ADD_MAP_STYLE_ID", {
  enumerable: true,
  get: function get() {
    return _defaultSettings.ADD_MAP_STYLE_ID;
  }
});
Object.defineProperty(exports, "AGGREGATION_TYPES", {
  enumerable: true,
  get: function get() {
    return _defaultSettings.AGGREGATION_TYPES;
  }
});
Object.defineProperty(exports, "ALL_FIELD_TYPES", {
  enumerable: true,
  get: function get() {
    return _defaultSettings.ALL_FIELD_TYPES;
  }
});
Object.defineProperty(exports, "ANIMATION_WINDOW", {
  enumerable: true,
  get: function get() {
    return _defaultSettings.ANIMATION_WINDOW;
  }
});
Object.defineProperty(exports, "BASE_SPEED", {
  enumerable: true,
  get: function get() {
    return _defaultSettings.BASE_SPEED;
  }
});
Object.defineProperty(exports, "BUG_REPORT_LINK", {
  enumerable: true,
  get: function get() {
    return _userGuides.BUG_REPORT_LINK;
  }
});
Object.defineProperty(exports, "CHANNEL_SCALES", {
  enumerable: true,
  get: function get() {
    return _defaultSettings.CHANNEL_SCALES;
  }
});
Object.defineProperty(exports, "CHANNEL_SCALE_SUPPORTED_FIELDS", {
  enumerable: true,
  get: function get() {
    return _defaultSettings.CHANNEL_SCALE_SUPPORTED_FIELDS;
  }
});
Object.defineProperty(exports, "COLOR_RANGES", {
  enumerable: true,
  get: function get() {
    return _colorRanges.COLOR_RANGES;
  }
});
Object.defineProperty(exports, "DATASET_FORMATS", {
  enumerable: true,
  get: function get() {
    return _defaultSettings.DATASET_FORMATS;
  }
});
Object.defineProperty(exports, "DATA_TABLE_ID", {
  enumerable: true,
  get: function get() {
    return _defaultSettings.DATA_TABLE_ID;
  }
});
Object.defineProperty(exports, "DEFAULT_COLOR_RANGE", {
  enumerable: true,
  get: function get() {
    return _colorRanges.DEFAULT_COLOR_RANGE;
  }
});
Object.defineProperty(exports, "DEFAULT_LAYER_GROUPS", {
  enumerable: true,
  get: function get() {
    return _defaultSettings.DEFAULT_LAYER_GROUPS;
  }
});
Object.defineProperty(exports, "DEFAULT_MAP_STYLES", {
  enumerable: true,
  get: function get() {
    return _defaultSettings.DEFAULT_MAP_STYLES;
  }
});
Object.defineProperty(exports, "DEFAULT_NOTIFICATION_TOPICS", {
  enumerable: true,
  get: function get() {
    return _defaultSettings.DEFAULT_NOTIFICATION_TOPICS;
  }
});
Object.defineProperty(exports, "DEFAULT_NOTIFICATION_TYPES", {
  enumerable: true,
  get: function get() {
    return _defaultSettings.DEFAULT_NOTIFICATION_TYPES;
  }
});
Object.defineProperty(exports, "DEFAULT_TIME_FORMAT", {
  enumerable: true,
  get: function get() {
    return _defaultSettings.DEFAULT_TIME_FORMAT;
  }
});
Object.defineProperty(exports, "DELETE_DATA_ID", {
  enumerable: true,
  get: function get() {
    return _defaultSettings.DELETE_DATA_ID;
  }
});
Object.defineProperty(exports, "DIMENSIONS", {
  enumerable: true,
  get: function get() {
    return _defaultSettings.DIMENSIONS;
  }
});
Object.defineProperty(exports, "DataVizColors", {
  enumerable: true,
  get: function get() {
    return _customColorRanges.DataVizColors;
  }
});
Object.defineProperty(exports, "EDITOR_MODES", {
  enumerable: true,
  get: function get() {
    return _defaultSettings.EDITOR_MODES;
  }
});
Object.defineProperty(exports, "EXPORT_DATA_ID", {
  enumerable: true,
  get: function get() {
    return _defaultSettings.EXPORT_DATA_ID;
  }
});
Object.defineProperty(exports, "EXPORT_DATA_TYPE_OPTIONS", {
  enumerable: true,
  get: function get() {
    return _defaultSettings.EXPORT_DATA_TYPE_OPTIONS;
  }
});
Object.defineProperty(exports, "EXPORT_IMAGE_ID", {
  enumerable: true,
  get: function get() {
    return _defaultSettings.EXPORT_IMAGE_ID;
  }
});
Object.defineProperty(exports, "EXPORT_IMG_RATIOS", {
  enumerable: true,
  get: function get() {
    return _defaultSettings.EXPORT_IMG_RATIOS;
  }
});
Object.defineProperty(exports, "EXPORT_IMG_RATIO_OPTIONS", {
  enumerable: true,
  get: function get() {
    return _defaultSettings.EXPORT_IMG_RATIO_OPTIONS;
  }
});
Object.defineProperty(exports, "EXPORT_IMG_RESOLUTION_OPTIONS", {
  enumerable: true,
  get: function get() {
    return _defaultSettings.EXPORT_IMG_RESOLUTION_OPTIONS;
  }
});
Object.defineProperty(exports, "EXPORT_MAP_FORMATS", {
  enumerable: true,
  get: function get() {
    return _defaultSettings.EXPORT_MAP_FORMATS;
  }
});
Object.defineProperty(exports, "EXPORT_MAP_FORMAT_OPTIONS", {
  enumerable: true,
  get: function get() {
    return _defaultSettings.EXPORT_MAP_FORMAT_OPTIONS;
  }
});
Object.defineProperty(exports, "EXPORT_MAP_ID", {
  enumerable: true,
  get: function get() {
    return _defaultSettings.EXPORT_MAP_ID;
  }
});
Object.defineProperty(exports, "FIELD_AGGREGATORS", {
  enumerable: true,
  get: function get() {
    return _defaultSettings.FIELD_AGGREGATORS;
  }
});
Object.defineProperty(exports, "FIELD_OPTS", {
  enumerable: true,
  get: function get() {
    return _defaultSettings.FIELD_OPTS;
  }
});
Object.defineProperty(exports, "FIELD_TYPES_AGGREGATORS", {
  enumerable: true,
  get: function get() {
    return _defaultSettings.FIELD_TYPES_AGGREGATORS;
  }
});
Object.defineProperty(exports, "FILTER_TYPES", {
  enumerable: true,
  get: function get() {
    return _defaultSettings.FILTER_TYPES;
  }
});
Object.defineProperty(exports, "FPS", {
  enumerable: true,
  get: function get() {
    return _defaultSettings.FPS;
  }
});
Object.defineProperty(exports, "GEOJSON_FIELDS", {
  enumerable: true,
  get: function get() {
    return _defaultSettings.GEOJSON_FIELDS;
  }
});
Object.defineProperty(exports, "ICON_FIELDS", {
  enumerable: true,
  get: function get() {
    return _defaultSettings.ICON_FIELDS;
  }
});
Object.defineProperty(exports, "KEPLER_GL_NAME", {
  enumerable: true,
  get: function get() {
    return _defaultSettings.KEPLER_GL_NAME;
  }
});
Object.defineProperty(exports, "KEPLER_GL_VERSION", {
  enumerable: true,
  get: function get() {
    return _defaultSettings.KEPLER_GL_VERSION;
  }
});
Object.defineProperty(exports, "KEPLER_GL_WEBSITE", {
  enumerable: true,
  get: function get() {
    return _defaultSettings.KEPLER_GL_WEBSITE;
  }
});
Object.defineProperty(exports, "KeyEvent", {
  enumerable: true,
  get: function get() {
    return _keyevent["default"];
  }
});
Object.defineProperty(exports, "LAYER_BLENDINGS", {
  enumerable: true,
  get: function get() {
    return _defaultSettings.LAYER_BLENDINGS;
  }
});
Object.defineProperty(exports, "LAYER_TYPES", {
  enumerable: true,
  get: function get() {
    return _types.LAYER_TYPES;
  }
});
Object.defineProperty(exports, "MAP_CONTROLS", {
  enumerable: true,
  get: function get() {
    return _defaultSettings.MAP_CONTROLS;
  }
});
Object.defineProperty(exports, "MAX_DEFAULT_TOOLTIPS", {
  enumerable: true,
  get: function get() {
    return _defaultSettings.MAX_DEFAULT_TOOLTIPS;
  }
});
Object.defineProperty(exports, "PANELS", {
  enumerable: true,
  get: function get() {
    return _defaultSettings.PANELS;
  }
});
Object.defineProperty(exports, "PLOT_TYPES", {
  enumerable: true,
  get: function get() {
    return _filterUtils.PLOT_TYPES;
  }
});
Object.defineProperty(exports, "RESOLUTIONS", {
  enumerable: true,
  get: function get() {
    return _defaultSettings.RESOLUTIONS;
  }
});
Object.defineProperty(exports, "SCALE_FUNC", {
  enumerable: true,
  get: function get() {
    return _defaultSettings.SCALE_FUNC;
  }
});
Object.defineProperty(exports, "SCALE_TYPES", {
  enumerable: true,
  get: function get() {
    return _defaultSettings.SCALE_TYPES;
  }
});
Object.defineProperty(exports, "SIDEBAR_PANELS", {
  enumerable: true,
  get: function get() {
    return _defaultSettings.SIDEBAR_PANELS;
  }
});
Object.defineProperty(exports, "SORT_ORDER", {
  enumerable: true,
  get: function get() {
    return _defaultSettings.SORT_ORDER;
  }
});
Object.defineProperty(exports, "SPEED_CONTROL_RANGE", {
  enumerable: true,
  get: function get() {
    return _defaultSettings.SPEED_CONTROL_RANGE;
  }
});
Object.defineProperty(exports, "THEME", {
  enumerable: true,
  get: function get() {
    return _defaultSettings.THEME;
  }
});
Object.defineProperty(exports, "TOOLTIP_FORMATS", {
  enumerable: true,
  get: function get() {
    return _tooltip.TOOLTIP_FORMATS;
  }
});
Object.defineProperty(exports, "TOOLTIP_FORMAT_TYPES", {
  enumerable: true,
  get: function get() {
    return _tooltip.TOOLTIP_FORMAT_TYPES;
  }
});
Object.defineProperty(exports, "TRIP_ARC_FIELDS", {
  enumerable: true,
  get: function get() {
    return _defaultSettings.TRIP_ARC_FIELDS;
  }
});
Object.defineProperty(exports, "TRIP_POINT_FIELDS", {
  enumerable: true,
  get: function get() {
    return _defaultSettings.TRIP_POINT_FIELDS;
  }
});
Object.defineProperty(exports, "UNKNOWN_COLOR", {
  enumerable: true,
  get: function get() {
    return _defaultSettings.UNKNOWN_COLOR;
  }
});
Object.defineProperty(exports, "USER_GUIDE_DOC", {
  enumerable: true,
  get: function get() {
    return _userGuides.USER_GUIDE_DOC;
  }
});
Object.defineProperty(exports, "VizColorPalette", {
  enumerable: true,
  get: function get() {
    return _customColorRanges.VizColorPalette;
  }
});
var _defaultSettings = require("./default-settings");
var _userGuides = require("./user-guides");
var _customColorRanges = require("./custom-color-ranges");
var _colorRanges = require("./color-ranges");
var _keyevent = _interopRequireDefault(require("./keyevent"));
var _types = require("../layers/types");
var _filterUtils = require("../utils/filter-utils");
var _tooltip = require("./tooltip");
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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